import { useState } from "react";
import JobInfoItem from "../Common/Icon/JobInfoItem";

const JobContent = ({
  jobTypes,
  jobTitle,
  jobId,
  jobLink,
  skills,
  postedDate,
  jobCategory,
  jobLocation,
  jobSalary,
  description,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  // Function to toggle the full or truncated description
  const toggleDescription = () => {
    setIsExpanded(!isExpanded);
  };
  return (
    <div className="content">
      <ul className="content-list">
        {jobTypes.map((type, index) => (
          <li key={index} className={`item-${index + 1}`}>
            {type}
          </li>
        ))}
      </ul>
      <h3>
        <a href={jobLink}>{jobTitle}{" "}({jobId})</a>
      </h3>
      <ul className="content-list2">
        <li className="list-two">
          <i className="ri-book-2-line"></i>
          {skills}
        </li>
        <li className="list-two">
          <i className="ri-time-line"></i> {postedDate}
        </li>
      </ul>
      <ul className="content-list3">
        <JobInfoItem
          icon="ri-briefcase-line"
          label="Category"
          value={jobCategory}
        />
        <JobInfoItem
          icon="ri-map-pin-line"
          label="Location"
          value={jobLocation}
        />
        <JobInfoItem icon="ri-currency-line" label="Salary" value={jobSalary} />
      </ul>
      <ul className="content-list4">
        {isExpanded ? (
          <>
            {description}{" "}
            <span  className="truncate-text"></span>
          </>
        ) : (
          <>
            {description.substring(0, 300)}
            {description.length > 299 ? (
              <span>...</span>
            ) : (
              <></>
            )}
          </>
        )}
      </ul>
    </div>
  );
};

export default JobContent;
